import axios from 'axios';
import { trackError, resetIdentity, trackApiError, trackRequestTimeout, trackImageUploadFailed } from './services/analytics';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 
    (process.env.NODE_ENV === 'production' 
      ? 'https://frontend.shoppeappnow.com/api'  // Use nginx proxy
      : 'http://localhost:8000/api'
    ),
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 60000, // 60 seconds timeout for regular requests
});
//should work 
axiosInstance.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    console.log('🔐 Token added to request:', token.substring(0, 20) + '...');
  } else {
    console.warn('⚠️ No token found in localStorage');
    console.log('💡 Available localStorage keys:', Object.keys(localStorage));
  }
  
  // Increase timeout for requests with large payloads (like images)
  if (config.data && typeof config.data === 'object' && config.data.image) {
    config.timeout = 120000; // 2 minutes for image uploads
    console.log('📸 Image upload detected, extending timeout to 2 minutes');
  }
  
  return config;
});

axiosInstance.interceptors.response.use(
  response => {
    console.log('✅ API Response successful:', response.config.url);
    return response;
  },
  error => {
    console.error('❌ API Error:', {
      url: error.config?.url,
      status: error.response?.status,
      message: error.response?.data?.message || error.message,
      hasToken: !!localStorage.getItem('token')
    });
    
    // Track API errors in analytics
    trackError(error, `API Error: ${error.config?.url || 'unknown'}`);

    const endpoint = error.config?.url || 'unknown';
    // PostHog: structured failure events (additive — trackError above is unchanged)
    if (error.response && error.response.status) {
      trackApiError(error.response.status, endpoint);
    }

    // Handle timeout errors specifically
    if (error.code === 'ECONNABORTED' && error.message.includes('timeout')) {
      console.error('⏰ Request timed out:', error.config?.url);
      console.log('💡 Consider compressing images or checking network connection');
      trackRequestTimeout(endpoint);
      let isImageUpload = false;
      try {
        const d = error.config?.data;
        isImageUpload = typeof d === 'string' ? d.includes('"image"') : !!(d && d.image);
      } catch (e) { /* ignore */ }
      if (isImageUpload) trackImageUploadFailed(endpoint, 'timeout');
    }
    
    if (error.response && error.response.status === 401) {
      console.warn('🔄 Authentication failed, clearing token and redirecting to login');
      localStorage.removeItem('token');
      localStorage.removeItem('role');
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('shop_name');
      resetIdentity();
      window.location.href = '/login'; // Redirect to login page
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;